export const StandardErrorMessage = 'Sorry, we appear to have encountered an error while trying to load the page, please try again later.';
export const NotFoundErrorMessage = "Sorry, we couldn't find what you were looking for.";
export const ErrorCardStyle = 'flex flex-col items-center justify-center m-auto lg:w-[60%]';
